import React from 'react'
import axios from 'axios'
import {ServerConfig} from 'config'
import { Route, Redirect } from 'react-router-dom'
import {useSelector} from 'react-redux'

// nodejs library to set properties for components
import PropTypes from 'prop-types'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid, Hidden, Container } from '@material-ui/core'

import { Link } from 'react-router-dom';
import { getAllowedRoutes } from 'utils';
import { hasPermission } from 'utils/hasPermission';

import Page from 'components/Page/Page'
import Stats from './Stats.js'
import Plots from './Plots.js'

const useStyles = makeStyles((theme) => ({}))



const DashboardPage = (props) => {
    const auth = useSelector(state => state.auth)
    const classes = useStyles()

  if(!auth.access_token){
    return <Redirect to="/login" />
  }

  const isAdmin = hasPermission(auth.permissions, ['Admin', 'admin']);

  return (
    <Page title="Dashboard">
        <Container maxWidth={false}>
            <Typography color="primary" variant="h1">
                Dashboard
            </Typography>

            <Grid container spacing={2}>
                {isAdmin &&
                    <Stats />
                }

                {isAdmin &&
                    <Plots />
                }

          </Grid>
        </Container>
    </Page>
  )
}

export default DashboardPage

DashboardPage.propTypes = {
  children: PropTypes.node
}
